import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import DashboardCard, { EmptyState } from './DashboardCard';
import { fmtDateTime, fmtDuration } from './formatters';

/**
 * Latest deactivations matching the filters. InstallationName is usually blank on
 * deactivated rows, so the license number is shown instead of the machine.
 */
export default function RecentDeactivationsTable({ rows = [], action, sx }) {
  return (
    <DashboardCard title="Recent deactivations" action={action} flush sx={sx}>
      {rows.length === 0 ? (
        <EmptyState />
      ) : (
        <TableContainer>
          <Table size="small" sx={{ minWidth: 600, '& td, & th': { py: 1.25 }, '& tr > :first-of-type': { pl: 3 }, '& tr > :last-child': { pr: 3 } }}>
            <TableHead>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Product · license</TableCell>
                <TableCell>Active for</TableCell>
                <TableCell>Reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDateTime(r.deactivatedAt)}</TableCell>
                  <TableCell>{r.company}</TableCell>
                  <TableCell>
                    {r.product}
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontFamily: 'monospace' }}>
                      {r.licenseId}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDuration(r.activeSeconds)}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={r.isReplaced ? 'Replaced' : 'Released'}
                      title={r.isReplaced ? 'A new activation on the same license replaced this one' : 'Deactivated with no replacement'}
                      sx={r.isReplaced ? { bgcolor: '#ECEFF1', color: '#37474F' } : { bgcolor: '#FFF3E0', color: '#9A3412' }}
                    />
                    {r.deactivatedBy && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                        by {r.deactivatedBy}
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DashboardCard>
  );
}
